import { checkToken, checkUserType } from "../../utils/helper";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";

function Member({ children }) {
  const dispatch = useDispatch();

  if (checkUserType() !== "member") {
    return <Navigate to="/login" replace />;
  }

  return checkToken(dispatch)?.valid ? (
    children
  ) : (
    <Navigate to="/login" replace />
  );
}

export default Member;
